import { ref, watch, type Ref } from 'vue';

export function useLocalStorageCache<T>(key: string, initial: T): Ref<T> {
  const read = (): T => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw ? (JSON.parse(raw) as T) : initial;
    } catch {
      return initial;
    }
  };

  const state = ref(read()) as Ref<T>;

  watch(
    state,
    (value) => {
      try {
        window.localStorage.setItem(key, JSON.stringify(value));
      } catch {
        // best-effort: ignore quota/access errors
      }
    },
    { deep: true }
  );

  return state;
}
